import { Outlet, Navigate } from 'react-router-dom';
import { FC } from 'react';
import { MinimalLayout } from '@/components';
import { useAuthContext } from '@/providers';
import { AuthState } from '@/providers/auth';
import { getFirstAccessiblePath } from '@/menu-items/first-accessible-path';
import { IRouteProps } from '../types';

export const AuthRoute: FC<IRouteProps> = ({ redirectPath }) => {
	const { user, authState } = useAuthContext();
	if (authState === AuthState.Loading) return null;
	if (user?.role === undefined)
		return (
			<MinimalLayout>
				<Outlet />
			</MinimalLayout>
		);

	// Landing = prima pagină accesibilă rolului (redirectPath rămâne fallback).
	return <Navigate to={getFirstAccessiblePath(user, redirectPath)} replace />;
};
